module.exports = __webpack_public_path__ + "static/media/maison_sport_sante.fe2fc153.png";